import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Reveal } from './Section';
type Review = {
  initials: string;
  name: string;
  detail: string;
  quote: string;
};
const reviews: Review[] = [{
  initials: 'SM',
  name: 'Sebastián M.',
  detail: 'Buenos Aires · Joven Argentino',
  quote: 'Aprendí la estrategia en una tarde. Hice backtesting durante los 5 días recomendados y al 6º ya estaba operando con mucha más claridad.'
}, {
  initials: 'CR',
  name: 'Claudia R.',
  detail: 'Rosario · Inversor principiante',
  quote: 'Los 80 tips para arrancar en el mercado me cambiaron la forma de ver los gráficos. Ya puedo tener más claridad en mis operaciones.'
}, {
  initials: 'DP',
  name: 'Diego P.',
  detail: 'Córdoba · Inversor Mister',
  quote: 'El sistema de “Primero no perder” es único. Mis operaciones ahora se enfocan en respetar mi gestión de riesgo y no solamente ganar.'
}];
function GoldStars() {
  return <div className="mt-5 flex gap-1" aria-label="5 de 5 estrellas" data-id="element-205" data-mp="14r307fn59smf">
      {Array.from({
      length: 5
    }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-206" data-mp="1tx8uusr74zks" data-mpi={index} />)}
    </div>;
}
export function SocialProofReviews() {
  return <section className="w-full bg-ink-950 px-5 py-14 sm:py-16" data-id="element-207" data-mp="1k1nxj7x2onhd">
      <div className="mx-auto w-full max-w-4xl" data-id="element-208" data-mp="1jzb6m59c72s6">
        <Reveal data-id="element-209" data-mp="1p1acpmwgodst">
          <div className="text-center" data-id="element-210" data-mp="1p0qsfzjc9dbm">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-211" data-mp="2cptjtz3rykjb">
              Experiencias reales
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl" data-id="element-212" data-mp="2hnv1cfljybso">
              Claridad para empezar con método
            </h2>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-213" data-mp="27pp3c92v9pt3">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.08} data-id="element-214" data-mp="rc77ui0u7kou" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-brand/35 bg-black p-5 sm:p-6" data-id="element-215" data-mp="wbjv33vmetry">
                <div className="flex items-center gap-3" data-id="element-216" data-mp="2yxyxrff4pe48">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border border-brand/40 bg-brand-soft font-display text-sm font-bold text-brand" data-id="element-217" data-mp="2yxfenvdqsjom">
                    {review.initials}
                  </span>
                  <div className="min-w-0" data-id="element-218" data-mp="2k9uea9894yke">
                    <figcaption className="font-display text-sm font-bold text-white" data-id="element-219" data-mp="2k8t03vvxvvyg">
                      {review.name}
                    </figcaption>
                    <p className="mt-1 flex items-start gap-1 text-xs leading-snug text-gray-500" data-id="element-220" data-mp="2b84ot8xxk9p9">
                      <MapPinIcon className="mt-px h-3.5 w-3.5 flex-none" data-id="element-221" data-mp="2691ill67rxfp" />
                      <span data-id="element-222" data-mp="21agg1f3hp1o3">{review.detail}</span>
                    </p>
                  </div>
                </div>
                <blockquote className="mt-5 text-sm leading-relaxed text-gray-300" data-id="element-223" data-mp="4hy8qy45emw7">
                  “{review.quote}”
                </blockquote>
                <div className="mt-auto" data-id="element-224" data-mp="3vp0zjog2qr5w">
                  <GoldStars data-id="element-225" data-mp="72w4e5j8nqxr" />
                </div>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}